import { SVGProps } from 'react'

export function HeartIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M10.9597 2.06665C9.75301 2.06665 8.67301 2.65332 7.99967 3.55332C7.32634 2.65332 6.24634 2.06665 5.03967 2.06665C2.99301 2.06665 1.33301 3.73332 1.33301 5.79332C1.33301 6.58665 1.45967 7.31998 1.67967 7.99998C2.73301 11.3333 5.97967 13.3266 7.58634 13.8733C7.81301 13.9533 8.18634 13.9533 8.41301 13.8733C10.0197 13.3266 13.2663 11.3333 14.3197 7.99998C14.5397 7.31998 14.6663 6.58665 14.6663 5.79332C14.6663 3.73332 13.0063 2.06665 10.9597 2.06665Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function StarIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M3.8269 10.6667C3.90023 10.34 3.7669 9.87337 3.53357 9.64004L1.91356 8.02004C1.4069 7.51337 1.2069 6.97337 1.35356 6.50671C1.5069 6.04004 1.98023 5.72004 2.6869 5.60004L4.7669 5.25337C5.0669 5.20004 5.43356 4.93337 5.57356 4.66004L6.72023 2.36004C7.05357 1.70004 7.5069 1.33337 8.00023 1.33337C8.49357 1.33337 8.9469 1.70004 9.28023 2.36004L10.4269 4.66004C10.5136 4.83337 10.6936 5.00004 10.8869 5.11337L3.7069 12.2934C3.61356 12.3867 3.45356 12.3 3.48023 12.1667L3.8269 10.6667Z'
				fill='currentColor'
			/>
			<path
				d='M12.4662 9.64001C12.2262 9.88001 12.0929 10.34 12.1729 10.6667L12.6329 12.6733C12.8262 13.5067 12.7062 14.1333 12.2929 14.4333C12.1262 14.5533 11.9262 14.6133 11.6929 14.6133C11.3529 14.6133 10.9529 14.4867 10.5129 14.2267L8.55954 13.0667C8.25288 12.8867 7.74621 12.8867 7.43954 13.0667L5.48621 14.2267C4.74621 14.66 4.11288 14.7333 3.70621 14.4333C3.55288 14.32 3.43954 14.1667 3.36621 13.9667L11.4729 5.86001C11.7795 5.55335 12.2129 5.41335 12.6329 5.48668L13.3062 5.60001C14.0129 5.72001 14.4862 6.04001 14.6395 6.50668C14.7862 6.97335 14.5862 7.51335 14.0795 8.02001L12.4662 9.64001Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function ClockIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
			<path
				d='M10.0003 1.66675C5.40866 1.66675 1.66699 5.40841 1.66699 10.0001C1.66699 14.5917 5.40866 18.3334 10.0003 18.3334C14.592 18.3334 18.3337 14.5917 18.3337 10.0001C18.3337 5.40841 14.592 1.66675 10.0003 1.66675ZM13.6253 12.9751C13.5087 13.1751 13.3003 13.2834 13.0837 13.2834C12.9753 13.2834 12.867 13.2584 12.767 13.1917L10.1837 11.6501C9.54199 11.2667 9.06699 10.4251 9.06699 9.68341V6.26675C9.06699 5.92508 9.35033 5.64175 9.69199 5.64175C10.0337 5.64175 10.317 5.92508 10.317 6.26675V9.68341C10.317 9.98341 10.567 10.4251 10.8253 10.5751L13.4087 12.1167C13.7087 12.2917 13.8087 12.6751 13.6253 12.9751Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function WalletBoldSmallIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M16.0874 10.23V10.98C16.0874 11.1825 15.9299 11.3475 15.7199 11.355H14.6249C14.2274 11.355 13.8674 11.0625 13.8374 10.6725C13.8149 10.44 13.9049 10.2225 14.0549 10.0725C14.1899 9.92998 14.3774 9.85498 14.5799 9.85498H15.7124C15.9299 9.86248 16.0874 10.0275 16.0874 10.23Z'
				fill='currentColor'
			/>
			<path
				d='M13.4929 9.51748C13.1179 9.88498 12.9379 10.4325 13.0879 11.0025C13.2829 11.7 13.9654 12.1425 14.6854 12.1425H15.3379C15.7504 12.1425 16.0879 12.48 16.0879 12.8925V13.035C16.0879 14.5875 14.8204 15.855 13.2679 15.855H4.65789C3.10539 15.855 1.83789 14.5875 1.83789 13.035V7.98748C1.83789 7.06498 2.28039 6.24748 2.96289 5.73748C3.43539 5.37748 4.02039 5.16748 4.65789 5.16748H13.2679C14.8204 5.16748 16.0879 6.43498 16.0879 7.98748V8.31748C16.0879 8.72998 15.7504 9.06748 15.3379 9.06748H14.5729C14.1529 9.06748 13.7704 9.23248 13.4929 9.51748Z'
				fill='currentColor'
			/>
			<path
				d='M12.1503 3.615C12.3528 3.8175 12.1803 4.1325 11.8953 4.1325L6.13529 4.125C5.80529 4.125 5.63279 3.72 5.87279 3.4875L7.08779 2.265C8.11529 1.245 9.78029 1.245 10.8078 2.265L12.1203 3.5925C12.1278 3.6 12.1428 3.6075 12.1503 3.615Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function ChartSquareIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM6.8325 12.675C6.8325 12.885 6.6675 13.05 6.4575 13.05H4.365C4.155 13.05 3.99 12.885 3.99 12.675V9.21C3.99 8.7375 4.3725 8.355 4.845 8.355H6.4575C6.6675 8.355 6.8325 8.52 6.8325 8.73V12.675ZM10.4175 12.675C10.4175 12.885 10.2525 13.05 10.0425 13.05H7.95C7.74 13.05 7.575 12.885 7.575 12.675V5.805C7.575 5.3325 7.9575 4.95 8.43 4.95H9.57C10.0425 4.95 10.425 5.3325 10.425 5.805V12.675H10.4175ZM14.01 12.675C14.01 12.885 13.845 13.05 13.635 13.05H11.5425C11.3325 13.05 11.1675 12.885 11.1675 12.675V10.0125C11.1675 9.8025 11.3325 9.6375 11.5425 9.6375H13.155C13.6275 9.6375 14.01 10.02 14.01 10.4925V12.675Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function GiftIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M15 9V13.5C15 15.1575 13.6575 16.5 12 16.5H6C4.3425 16.5 3 15.1575 3 13.5V9C3 8.5875 3.3375 8.25 3.75 8.25H5.2275C5.64 8.25 5.9775 8.5875 5.9775 9V11.355C5.9775 11.91 6.285 12.42 6.7725 12.6825C6.99 12.8025 7.23 12.8625 7.4775 12.8625C7.7625 12.8625 8.0475 12.78 8.295 12.615L9.0075 12.15L9.6675 12.5925C10.125 12.9 10.71 12.9375 11.1975 12.675C11.6925 12.4125 12 11.91 12 11.3475V9C12 8.5875 12.3375 8.25 12.75 8.25H14.25C14.6625 8.25 15 8.5875 15 9Z'
				fill='currentColor'
			/>
			<path
				d='M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z'
				fill='currentColor'
			/>
			<path
				d='M8.73008 3.75008H4.59008C4.33508 3.47258 4.34258 3.04508 4.61258 2.77508L5.67758 1.71008C5.95508 1.43258 6.41258 1.43258 6.69008 1.71008L8.73008 3.75008Z'
				fill='currentColor'
			/>
			<path
				d='M13.4027 3.75008H9.2627L11.3027 1.71008C11.5802 1.43258 12.0377 1.43258 12.3152 1.71008L13.3802 2.77508C13.6502 3.04508 13.6577 3.47258 13.4027 3.75008Z'
				fill='currentColor'
			/>
			<path
				d='M10.4776 8.25C10.8901 8.25 11.2276 8.5875 11.2276 9V11.3475C11.2276 11.9475 10.5601 12.3075 10.0651 11.97L9.39008 11.52C9.14258 11.355 8.82008 11.355 8.56508 11.52L7.86008 11.985C7.36508 12.315 6.70508 11.955 6.70508 11.3625V9C6.70508 8.5875 7.04258 8.25 7.45508 8.25H10.4776Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function MoneysBoldIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
			<path
				d='M14.3772 4.97989C14.0547 3.35239 12.8472 2.63989 11.1672 2.63989H4.58223C2.60223 2.63989 1.28223 3.62989 1.28223 5.93989V9.80239C1.28223 11.4674 1.96473 12.4424 3.08973 12.8624C3.25473 12.9224 3.43473 12.9749 3.62223 13.0049C3.92223 13.0724 4.24473 13.1024 4.58223 13.1024H11.1747C13.1547 13.1024 14.4747 12.1124 14.4747 9.80239V5.93989C14.4747 5.58739 14.4447 5.27239 14.3772 4.97989Z'
				fill='currentColor'
			/>
			<path
				d='M16.7253 8.18996V12.0525C16.7253 14.3625 15.4053 15.36 13.4178 15.36H6.83281C6.27031 15.36 5.76781 15.2775 5.33281 15.1125C4.98031 14.985 4.67281 14.7975 4.42531 14.5575C4.29031 14.43 4.39531 14.2275 4.58281 14.2275H11.1678C13.9428 14.2275 15.5928 12.5775 15.5928 9.80996V5.93996C15.5928 5.75996 15.7953 5.64746 15.9228 5.78246C16.4328 6.32246 16.7253 7.10996 16.7253 8.18996Z'
				fill='currentColor'
			/>
		</svg>
	)
}
